<template>
    <div>

        <vue-headful title="Employee Recognitions :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-trophy"></i> Recognitions</li>
                <li class="ml-3">
                    <router-link class="btn btn-sm btn-success" :to="`/employees/recognition/edit${this.employee_id ? '?employee_id='+this.employee_id : ''}`">
                        <i class="fa fa-plus"></i> Add
                    </router-link>
                </li>
            </ol>
        </h4>

        <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
            <template v-for="(tab, key) in settingsTabs">
                <b-nav-item :active="curTab === key" @click="curTab = key">
                    {{ tab }}
                </b-nav-item>
            </template>
        </ul>

        <div class="mb-2 mb-lg-0 d-lg-none d-block">
          <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
            <template v-for="(tab, key) in settingsTabs">
                <b-dropdown-item :active="curTab === key" @click="curTab = key">
                    {{ tab }}
                </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>

        <div class="card" v-show="curTab === 'list'">
            <div class="card-body">
                <employee-recognition-list ref="empRecogList" :saveState="true" />
            </div>
        </div>

        <template v-if="canManage">
            <div class="card" v-show="curTab === 'settings'">
                <div class="card-header">
                    <strong>Recognition Types</strong> <router-link :to="`/employees/recognitions-types/edit`" class="btn btn-sm btn-info"><i class="fa fa-plus"></i> Add</router-link>
                </div>
                <div class="card-body">
                    <recognition-list />
                </div>
            </div>
            <div class="card" v-show="curTab == 'alerts'">
                <div class="card-body">
                    <v-client-table ref="recogEmailAlerts" :columns="columns" :options="options" :data="alerts">

                        <div slot="afterFilter" class="ml-2">
                            <router-link class="btn btn-outline-success" :to="`/employees/recognitions/alerts/create`">
                                <i class="fa fa-plus"></i> Add
                            </router-link>
                        </div>

                        <template slot="id" slot-scope="props">
                            <router-link class="btn btn-sm btn-default" :to="`/employees/recognitions/alerts/edit/${props.row.id}`" title="Edit Alert">
                                <span class=""><i class="fa fa-edit"></i></span>
                            </router-link>
                            <router-link class="btn btn-sm btn-default" :to="`/employees/recognitions/alerts/delete/${props.row.id}`" title="Delete Alert" v-if="false">
                                <span class="text-danger"><i class="fa fa-trash"></i></span>
                            </router-link>
                        </template>

                        <template slot="is_active" slot-scope="props">
                            <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                            <label class="badge badge-warning" v-else>Inactive</label>
                        </template>

                        <template slot="child_row" slot-scope="props">
                            <div><strong>Conditions:</strong></div>
                            <div v-for="cond in props.row.conditions">
                                {{ cond.field_label }} {{ cond.logic }} {{ cond.cond_label }}
                            </div>

                            <div class="mt-2"><strong>Recipients:</strong></div>
                            <div v-for="recip in props.row.recipients">
                                {{ recip.target_type }}
                                <span v-if="recip.target_label && recip.target_label.FirstName">- {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}</span>
                                <span v-else-if="recip.target_label">- {{ recip.target_label }}</span>
                            </div>
                        </template>

                    </v-client-table>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['employee_id'],

        data: function() {
            return {
                curTab: 'list',

                alerts: [],
                columns: ['id', 'alert_name', 'is_active', 'description'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        alert_name: 'Alert Name',
                        is_active: 'Active',
                        description: 'Description',
                    },
                },

                settingsTabs: {
                    list: 'Recognitions',
                    settings: 'Settings',
                    alerts: 'Email Alert Settings',
                },
            }
        },

        computed: {
            canManage(){
                //Check for admin
                return this.$store.state.user.is_admin && !this.employee_id;
            },

            tabButtonTitle(){
                //Send it
                return '<i class="fa fa-bars"></i> ' + this.settingsTabs[this.curTab];
            },
        },

        methods: {
            //Load up
            getRecogAlerts(){
                //Send it
                this.$http
                    .get('/employees/recognitions/alerts/list')
                    .then(response => {
                        //Set all the data
                        this.alerts = response.data.alerts;
                    })
                    .catch(response => {
                        //Set
                    })
                    .then(() => {

                    });
            },
        },

        mounted(){
            //Send it
            if(this.canManage)
            {
                //Get the data
                this.getRecogAlerts();

                //Check for a hash
                if(window.location.hash)
                {
                    //Set the current tab
                    this.curTab = window.location.hash.replace('#', '');
                }
            }

            //Focus on the SEarch Input
            this.$refs.empRecogList.$refs.recognitionsTable.$refs.genericFilter.focus();
        }
    }
</script>
